import React from "react"
import { StyleSheet, View } from "react-native"
import TextM from "../../common/components/text/TextM"
import { IconButton } from "react-native-paper"
import { theme } from "../../common/theme/theme"
import { getUpdateAllocationHoursFn } from "../../common/student-diagnostic-stepper/HourAllocationStep"

export const HoursAllocationSection = ({
    selectedSubjects,
    hoursPerWeek,
    allocation,
    setAllocation,
}) => {
    const selectedSubjectIds = selectedSubjects.map((x) => x.id)

    const updateHours = getUpdateAllocationHoursFn({
        selectedSubjects: selectedSubjectIds,
        hoursPerWeek,
        allocation,
        setAllocation,
    })

    return (
        <View style={styles.container}>
            {selectedSubjects.map((subject) => (
                <HoursAllocationRow
                    key={subject.id}
                    subject={subject}
                    hours={allocation[subject.id]}
                    maxHours={hoursPerWeek - (selectedSubjectIds.length - 1)}
                    updateHours={updateHours}
                />
            ))}
        </View>
    )
}

const HoursAllocationRow = ({ subject, hours, maxHours, updateHours }) => (
    <View key={subject.id} style={[styles.subject]}>
        <TextM fontWeight="Medium" fontSize={16} style={{ marginRight: 10 }}>
            {subject.name}
        </TextM>
        <IconButton
            icon="minus"
            size={16}
            disabled={hours <= 1}
            onPress={() => updateHours(subject.id, Math.max(1, hours - 1))}
            style={{
                backgroundColor:
                    hours <= 1
                        ? theme.colors.lighter
                        : theme.colors.primaryLighter,
                ...styles.iconButton,
            }}
            iconColor={hours <= 1 ? theme.colors.light : theme.colors.primary}
        />

        <View style={styles.hours}>
            <TextM fontWeight="Bold" fontSize={16} color={theme.colors.primary}>
                {hours}
            </TextM>
        </View>

        <IconButton
            icon="plus"
            size={16}
            disabled={hours >= maxHours}
            onPress={() =>
                updateHours(subject.id, Math.min(maxHours, hours + 1))
            }
            style={{
                backgroundColor:
                    hours >= maxHours
                        ? theme.colors.lighter
                        : theme.colors.primaryLighter,
                ...styles.iconButton,
            }}
            iconColor={
                hours >= maxHours ? theme.colors.light : theme.colors.primary
            }
        />
    </View>
)

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        flexWrap: "wrap",
        gap: 10,
    },
    subject: {
        flexDirection: "row",
        alignItems: "center",
        gap: 5,
        borderWidth: 1,
        borderColor: theme.colors.light,
        borderRadius: 15,
        padding: 8,
    },
    iconButton: {
        width: 24,
        height: 24,
        margin: 0,
    },
    hours: {
        backgroundColor: theme.colors.primaryLighter,
        borderColor: theme.colors.primary,
        borderWidth: 1,
        borderRadius: 8,
        paddingVertical: 8,
        paddingHorizontal: 16,
        // minWidth: 40,
        // alignItems: "center",
    },
})
